import { Service } from "@flexidao/dto";

export const formatService = (service: Service): string => {
    switch (service) {
        case Service.BIM:
            return "BIM";
        case Service.CfeDiagnostic:
            return "CFE diagnostic";
        case Service.GridEmissions:
            return "Grid emissions";
        case Service.MeterDataSimulation:
            return "Meter data simulation";
        case Service.MeterData:
            return "Meter data";
        case Service.TwentyFourSeven:
            return "24/7";
        case Service.EacData:
            return "EAC data";
        case Service.ReportHub:
            return "Report hub";
        case Service.FinancialData:
            return "Financial data";
        case Service.GcRegistryBridge:
            return "GC registry bridge";
    }
};
